module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"give":"Give to others","signup":"Sign up now","turnup":"Transfer to full course"},"zh":{"give":"赠课给他人","signup":"立即报名","turnup":"转报全阶"}}')
  delete Component.options._Ctor
}
